<!--既往内镜治疗-->
<script setup>
import { computed, reactive, watch,ref } from "vue";
import { useCrfStore } from "@/stores/crf";
const crfStore = useCrfStore();
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen
//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0


// 定义组件属性
const props = defineProps({
  formModel: {},
  prefix: "",
  type: null
});
//prefix
let attrs = ref('【'+ (notScreen.value?'补充':'既往') +'内镜治疗】')







// 表单对象
const model = reactive(props.formModel);
// console.log(model.fields[`${props.type}`].arrays,1111);
// model.fields[`${props.type}`].arrays ?'' :model.fields[`${props.type}`].arrays = [{'手术名称':'','手术日期':''}]
// console.log(model.fields[`${props.type}`].arrays,222);

// 值的保存应该每个记录的值是一个对象，然后放进数组
const arrays = computed(() => {
  // 左侧为空（null或undefined）时才赋值
  model.fields[`${props.type}`]??= {}
  model.fields[`${props.type}`].endoscopeArrays ? '' : model.fields[`${props.type}`].endoscopeArrays = []
  // model.fields[`${props.type}`].endoscopeArrays.push({'手术名称':'','手术日期':''})
  return model.fields[`${props.type}`].endoscopeArrays;
});


let title = ref(attrs.value.replace("【", "").replace("】", ""))
// const title = computed(() => {
//   if (props.prefix) {
//     return props.prefix.replace("【", "").replace("】", "");
//   } else {
//     return "";
//   }
// });

// const isVisible = computed(() => {
//   let result = {};
//   // 单选的选择
//   [`${props.prefix}受试者是否进行过${title.value}_是`].forEach((field) => {
//     const key = field.split("_")[0];
//     const value = field.split("_")[1];
//     result[field] = model.fields[props.type][key] === value;
//   });

//   return result;
// });

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});
// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields[${props.type}]['endoscopeArrays'][${prop}]`;
};
// console.log( model.fields)
// console.log( model.fields[`${props.type}`],`${props.prefix}`,"既往内镜");
</script>
<!-- <template> -->
  <template v-if="crfFields">
     <!-- <p>----{{ attrs }}--{{title}}--</p> -->
    <h3>{{ title }}</h3>
    <el-form-item label="是否适用肝筛选期内镜治疗数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['内镜治疗是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields?.['内镜治疗是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="'是否' + (notScreen?'新增':'') + title" class="redStar">
          <el-radio-group v-model="crfFields[`${attrs}是否进行过${title}`]" >
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>
          <!-- <p>{{  console.log(model,props.type,model.fields[`${props.type}`],model.fields[`${props.type}`].arrays ) }}</p> -->
        </el-form-item>

        <template v-for="(item, index) in arrays" :key="index" v-if="crfFields?.[`${attrs}是否进行过${title}`] == '是'">
          <h4>第{{ index + 1 }}次内镜治疗</h4>
          <el-form-item class="redStar" :label="'第'+(index + 1) +'次内镜治疗方式'" :prop="itemProp(`${index}['手术名称']`)" :rules="crfStore.radioRules(`${index + 1}内镜治疗方式`)">
            <!-- <el-input v-model="arrays[index]['手术名称']" placeholder="请输入手术名称"></el-input> -->
             <!-- <p>{{ itemProp(`${index}['手术名称']`) }}</p> -->
            <el-radio-group v-model="arrays[index]['手术名称']">
              <el-radio label="套扎" prop="套扎"></el-radio>
              <el-radio label="硬化剂" prop="硬化剂"></el-radio>
              <el-radio label="套扎加硬化剂" prop="套扎加硬化剂"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="'第'+(index + 1) +'次内镜治疗日期'" class="redStar" :prop="itemProp(`${index}['手术日期']`)" :rules="crfStore.dateRules('手术日期')">
            <el-date-picker v-model="arrays[index]['手术日期']"
                            type="date" placeholder="选择手术日期"
                            value-format="YYYY-MM-DD" />
          </el-form-item>
          <button class="del" v-if="arrays.length>1" @click.prevent="arrays.splice(index,1)">删除第{{ index + 1 }}次内镜治疗记录</button>
          <hr>
        </template>
        <p><button v-if="arrays?.length <9 && crfFields[`${attrs}是否进行过${title}`] == '是'" class="add" @click.prevent="arrays.push({'手术名称':'','手术日期':''});">增加内镜治疗记录</button></p>
        <!-- <p @click="console.log(arrays)"> 打印总的记录</p> -->
      </template>
  </template>
<!-- </template> -->

<style scoped>
.del{
  margin-left: 261px;
}
.add{
  margin-left: 261px;
}
</style>